import React from "react";
import ReactDOM from "react-dom";
import CancelButton from "../button/CancelButton";
import Button from "../button/Button";

const EditMerchandiseRequestModel = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitLoding,
  _id,
  status,
}) => {
  const [productLink, setProductLink] = React.useState("");
  const [description, setDescription] = React.useState("");

  const handleSubmit = async () => {
    console.log("Submit button clicked");
    await onSubmit({ productLink, description, _id, status });
    onClose(); // Uncomment if you want the modal to close after submission
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Add Product Details</h2>
        <div className="mb-4">
          <label
            htmlFor="productLink"
            className="block text-sm font-medium text-gray-700"
          >
            Product Link
          </label>
          <input
            type="text"
            id="productLink"
            value={productLink}
            onChange={(e) => setProductLink(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-500"
            placeholder="Enter product link"
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="description"
            className="block text-sm font-medium text-gray-700"
          >
            Description
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-500"
            placeholder="Enter description"
          />
        </div>
        <div className="flex justify-end space-x-2">
          <CancelButton text={"Cancel"} onClick={onClose} />
          <Button
            text={"Submit"}
            onClick={handleSubmit}
            isLoading={isSubmitLoding}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EditMerchandiseRequestModel;
